import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { ScanRunState } from "types/generated";
import { AccessResult, hasAtLeastWriteAccess, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

type ScanRunForStop = {
  state: ScanRunState;
  scan: { space: { id: string } };
};

const useCanStopScanRun = (): ((scanRun?: ScanRunForStop) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (scanRun?: ScanRunForStop) => {
      if (!scanRun || scanRun.state !== ScanRunState.Scanning) {
        return { result: false };
      }

      if (viewer.admin || hasAtLeastWriteAccess(viewer, scanRun.scan.space.id)) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanStopScanRun;
